import { render, staticRenderFns } from "./LaudoBacenResolucaoModal.vue?vue&type=template&id=31ffaa19&scoped=true&lang=pug"
import script from "./LaudoBacenResolucaoModal.vue?vue&type=script&lang=js"
export * from "./LaudoBacenResolucaoModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoBacenResolucaoModal.vue?vue&type=style&index=0&id=31ffaa19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ffaa19",
  null
  
)

export default component.exports